import React, { useContext } from 'react'
import { Link, NavLink } from 'react-router-dom'
import logo from '../../assets/logo.png';
import { AuthContext, logOut } from '../../contexts/AuthProvider';


const Navbar = () => {
  const { user, logOut } = useContext(AuthContext);

  const menuItems = <>
    <li><NavLink to='/'>Home</NavLink></li>
    <li><NavLink to='/category'>Category</NavLink></li>
    <li><NavLink to='/blog'>Blog</NavLink></li>
    {
      user && <li><NavLink to='/dashboard'>Dashboard</NavLink></li>
    }
    {
      user ? <><li onClick={logOut} className='lg:hidden'><NavLink to='/login'>Log Out</NavLink></li></> :
        <li className='lg:hidden'><NavLink to='/login'>Login</NavLink></li>
    }

  </>

  return (

    <div className=" lg:w-[1140px] mx-auto flex justify-center items-center border-b-2">

      <div className='navbar'>
        <div className="navbar-start">

          <div className="dropdown">
            <label tabIndex={0} className="btn btn-ghost lg:hidden">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
            </label>
            <ul tabIndex={1} className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
              {menuItems}
            </ul>
          </div>

          <div>
            <Link to='/' className="btn btn-ghost normal-case text-xl">
              <img className='w-40' src={logo} alt="" />
            </Link>
          </div>
        </div>

        <div className="navbar-center hidden lg:flex">
          <ul className="menu menu-horizontal p-0">
            {menuItems}
          </ul>
        </div>

        <div className="navbar-end hidden lg:flex">
          {
            user ? <><Link to='/login' onClick={logOut} className="btn btn-primary font-normal tracking-wider text-white ">Log Out</Link></> :

              <Link to='/login' className="btn btn-primary font-normal tracking-wider text-white ">Login Now</Link>
          }
        </div>

      </div>


      <label htmlFor="dashboard-drawer" tabIndex={0} className="btn btn-ghost drawer-button lg:hidden">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
      </label>

    </div>
  )
}

export default Navbar

